export const kpV = (r) => (Number(r.impact) || 0) * (Number(r.probability) || 0);
export const kpCritical = (r) => kpV(r) >= 64 || (Number(r.impact) || 0) >= 9;

export default function KeyPersonBlueprint({ doc }) {
  const roles = [...(doc.payload?.roles || [])].filter((r) => r.position || r.incumbent);
  roles.sort((a, b) => (kpCritical(b) - kpCritical(a)) || (kpV(b) - kpV(a)));
  return (
    <div data-testid="keyperson-blueprint">
      <div className="bg-white border border-slate-200 rounded-sm overflow-hidden">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500">
              <th className="px-4 py-2.5 font-semibold">Critical Position</th>
              <th className="px-4 py-2.5 font-semibold">Incumbent</th>
              <th className="px-3 py-2.5 font-semibold text-center">Impact</th>
              <th className="px-3 py-2.5 font-semibold text-center">Flight Risk</th>
              <th className="px-3 py-2.5 font-semibold text-center">V Rank</th>
              <th className="px-4 py-2.5 font-semibold">Mitigating Controls / Succession</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {roles.length === 0 && <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-300">No critical positions recorded.</td></tr>}
            {roles.map((r) => {
              const v = kpV(r);
              const critical = kpCritical(r);
              return (
                <tr key={r.id} data-testid={`keyperson-row-${r.id}`} className={critical ? "bg-red-50 border-l-4 border-l-red-600" : ""}>
                  <td className="px-4 py-3 text-slate-800 font-medium">
                    {r.position || <span className="text-slate-300">—</span>}
                    {critical && <span data-testid={`keyperson-critical-chip-${r.id}`} className="ml-2 px-2 py-0.5 rounded-sm text-[10px] font-bold uppercase bg-red-600 text-white align-middle">Critical exposure</span>}
                  </td>
                  <td className="px-4 py-3 text-slate-700">{r.incumbent || <span className="text-slate-300">—</span>}</td>
                  <td className={`px-3 py-3 text-center font-mono font-bold ${(Number(r.impact) || 0) >= 9 ? "text-red-700" : ""}`}>{r.impact || "—"}</td>
                  <td className="px-3 py-3 text-center font-mono">{r.probability || "—"}</td>
                  <td className={`px-3 py-3 text-center font-mono font-bold ${critical ? "text-red-700" : "text-slate-700"}`} data-testid={`keyperson-v-${r.id}`}>{v}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-pre-wrap">{r.controls || <span className="text-slate-300">—</span>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-xs text-slate-400 font-mono">Vulnerability Rank V = Operational Impact × Flight Risk · V ≥ 64 or Impact ≥ 9 flags a Critical Exposure.</p>
    </div>
  );
}
